import type { AliiConnectType } from '$lib/models/integration/aliiConnectType';

/**
 * Case-insensitive check for a client's AliiConnectType against a target integration key.
 *
 * Central helper so the drawer's Integrations dispatcher (and any callers that need the same
 * conditional) share one definition of "this client is a Tass V2 / AccountsIQ / Blackbaud /
 * Xero V3 / ... client". Comparison collapses whitespace and case; passes on `null` /
 * `undefined` return `false`.
 *
 * `target` is typed against the `AliiConnectType` union so typos and drift from the C# enum
 * are caught at compile time.
 */
export function isIntegration(connectionType: string | undefined | null, target: AliiConnectType): boolean {
  return (connectionType ?? '').trim().toLowerCase() === target.trim().toLowerCase();
}
